import { Dialog, DialogContent } from '@/components/atoms/Dialog';
import MonitoringTutorialImg from '@/assets/images/MonitoringTutorial.png';

interface MonitoringTutorialOverlayProps {
  open: boolean;
  onClose: () => void;
}

const MonitoringTutorialOverlay = ({ open, onClose }: MonitoringTutorialOverlayProps) => {
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent noCloseBtn className="w-[560px] p-[30px]">
        <div className="flex flex-col items-center gap-[24px]">
          {/* 확장프로그램 상단 바 이미지 */}
          <div className="flex flex-col items-center gap-[10px]">
            <img
              src={MonitoringTutorialImg}
              alt="확장 프로그램 상단 바"
              className="w-full rounded-[8px] border border-gr-200"
            />
            <div className="text-center text-gr-600 Body5M14">
              상품 상단의 <span className="text-point-500">상품순위 모니터링</span> 버튼을
              눌러주세요
            </div>
          </div>

          {/* 안내 문구 */}
          <div className="flex flex-col items-center gap-[6px]">
            <div className="text-gr-900 Title3S18">상품 페이지로 이동했어요</div>
            <div className="text-center text-gr-700 Body5M14">
              상단 모니터링 버튼을 눌러주세요
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default MonitoringTutorialOverlay;
